export const SubscriptionPlan = {
  FREE: 0,
  // 1, 2, 3... は将来の通常サブスクリプション用に予約
  EARLY_ACCESS: 3, // これ以上のプランは全て EA 機能にアクセス可能
  CROWDFUNDING: 9, // クラファン特典（期間限定）
} as const;

export const isSubscribed = (plan: number): boolean =>
  plan >= 1;

export const isEarlyAccess = (plan: number): boolean =>
  plan >= SubscriptionPlan.EARLY_ACCESS;
